import { Route, Coordinates } from '@/types'

export const TOKEN =
  'pk.eyJ1IjoibmJydXN0aHVpemVuIiwiYSI6ImNrYjZiaTRpODB3Z3YyeG16cmNjZGx6aWgifQ.JlgZVHfDta6nen5W5_Xq9A'

const ENDPOINTS = {
  ROUTE: 'https://api.mapbox.com/matching/v5/mapbox/cycling/'
}

export const getBikeRoute = async (route: Route) => {
  let coordinatesArray

  coordinatesArray = route.steps
    .map(step => `${step.coordinates.lon},${step.coordinates.lat}`)
    .join(';')

  const parameters = [
    ['geometries', 'geojson'],
    ['overview', 'full'],
    ['radiuses', route.steps.map(() => 10).join(';')],
    ['access_token', TOKEN]
  ]
    .map(parameter => `${parameter[0]}=${parameter[1]}`)
    .join('&')

  const url = `${ENDPOINTS.ROUTE}${coordinatesArray}?${parameters}`

  return await (await fetch(url)).json()
}

export const getDistance = (
  startLatitude: number,
  startLongitude: number,
  destLatitude: number,
  destLongitude: number
) => {
  const latDelta = Math.abs(startLatitude - destLatitude)
  const longDelta = Math.abs(startLongitude - destLongitude)
  return Math.sqrt(Math.pow(latDelta, 2) + Math.pow(longDelta, 2))
}
